import { ShieldAlert } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { listExpensesAwaitingMyApproval } from '../expenses.api';
import { useExpenseCategories } from '../hooks/use-expense-categories';
import { useExpenseDecision } from '../hooks/use-expense-decision';
import { useExpenseList } from '../hooks/use-expense-list';
import { buildApprovalColumns } from './build-approval-columns';
import { ExpenseApprovalsTable } from './ExpenseApprovalsTable';
import { ExpenseDecisionDrawer } from './ExpenseDecisionDrawer';

/** The approver's queue: what their roles let them decide, oldest waiting first if they sort it so, and a drawer for each decision. */
export function ExpenseApprovalsTab() {
  const { state, list, isRefreshing, reload } = useExpenseList(listExpensesAwaitingMyApproval);
  const categories = useExpenseCategories();
  const decision = useExpenseDecision(reload);
  const columns = buildApprovalColumns({ list, categories, now: new Date(), onDecide: decision.open });

  return (
    <>
      {state.status === 'loading' && <TableSkeleton label="Loading approvals" withSearch />}
      {(state.status === 'error' || state.status === 'forbidden') && (
        <EmptyState
          icon={ShieldAlert}
          title="Couldn't load approvals"
          description="Something went wrong loading the expenses waiting for you. Try reloading the page."
        />
      )}
      {state.status === 'loaded' && <ExpenseApprovalsTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <ExpenseDecisionDrawer
        target={decision.target}
        error={decision.error}
        submitting={decision.submitting}
        onDecide={decision.decide}
        onClose={decision.close}
      />
    </>
  );
}
